module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/anna-dabrowska-8a041977f0503a42950e70d4bf643552.png";